import { useMediaQuery } from 'hooks';
import { SectionContainer, Button, ButtonSize } from 'ui';
import {
    sectionContainer,
    screenTablet,
    positionLeft,
    positionRight,
    layoutContainer
} from './reference-management.module.scss';
import { LayoutContainer } from 'layout';
import { Circle } from 'ui/circle';

export const ReferenceManagement = () => {
    const isTablet = useMediaQuery(`(min-width: ${screenTablet})`);

    return (
        <LayoutContainer className={layoutContainer}>
            <SectionContainer className={sectionContainer}>
                {!isTablet ? (
                    ''
                ) : (
                    <>
                        {' '}
                        <Circle position={positionLeft} />
                        <Circle position={positionRight} />
                    </>
                )}

                <h3>Reference management with no reference manager</h3>
                <p>
                    Goodbye, reference managers – your service is no longer required! Elumity manages citations and
                    references on the fly without other complicated software.
                </p>
                <a href={process.env.GATSBY_ELUMITY_APP_URL + '/signup'}>
                    <Button text="Try it now" size={ButtonSize.Medium} />
                </a>
            </SectionContainer>
        </LayoutContainer>
    );
};
